import { BASE_URL } from './Constants';

export const LOGIN_URL = `${BASE_URL}api/external/Common/Auth`;
